
<svg aria-hidden="true" width="32" height="32" viewBox="-2 -1 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="15.5" stroke="#6E6F74" />
  <path d="M12.4805 21.6367H14.2305V16.918H19.0742V15.4414H14.2305V11.8711H19.5195V10.3633H12.4805V21.6367Z" fill="#6E6F74" />
</svg>
